import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import MaintenanceActions from './maintenance.action-types';

@Injectable()
export class MaintenanceEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    // Maintenance Context
    requestMaintenanceContext$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceContext),
                tap(action => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceContext, {
                        locationContext: action.locationContext,
                        deviceId: action.deviceId
                    });
                })
            ),
        { dispatch: false }
    );
    triggerTestCommand$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.triggerTestCommand),
                tap(action => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceTestCommand, {
                        locationContext: action.commandContext.locationContext,
                        command: action.commandContext.command,
                        deviceId: action.deviceId,
                        operator: action.operator
                    });
                })
            ),
        { dispatch: false }
    );

    // Maintenance Mode
    setMaintenanceMode$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.setMaintenanceMode),
                tap(action => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceMode, {
                        locationContext: action.maintenanceModeContext.locationContext,
                        inMaintenanceMode: action.maintenanceModeContext.inMaintenanceMode
                    });
                })
            ),
        { dispatch: false }
    );

    requestMaintenanceModeContext$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceModeContext),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceModeContext, { locationContext });
                })
            ),
        { dispatch: false }
    );

    // Links
    requestMaintenanceLinks$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceLinks),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceLinks, { locationContext });
                })
            ),
        { dispatch: false }
    );

    // Commands
    requestMaintenanceCommands$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceCommands),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceCommands, { locationContext });
                })
            ),
        { dispatch: false }
    );

    triggerMaintenanceCommand$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.triggerMaintenanceCommand),
                tap(action => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceCommand, {
                        locationContext: action.maintenanceCommandContext.locationContext,
                        command: action.maintenanceCommandContext.command
                    });
                })
            ),
        { dispatch: false }
    );

    // Failed Tests
    requestMaintenanceFailedTests$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceFailedTests),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceFailedTests, { locationContext });
                })
            ),
        { dispatch: false }
    );

    // Components
    requestMaintenanceComponents$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceComponents),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceComponents, { locationContext });
                })
            ),
        { dispatch: false }
    );

    // Schedule
    requestMaintenanceSchedule$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceSchedule),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceSchedule, { locationContext });
                })
            ),
        { dispatch: false }
    );

    // Tasks Completed
    requestMaintenanceTasksCompleted$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.requestMaintenanceTasksCompleted),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceTasksCompleted, {
                        locationContext
                    });
                })
            ),
        { dispatch: false }
    );

    addMaintenanceTask$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MaintenanceActions.addMaintenanceTaskCompleted),
                map(action => action),
                tap(action =>
                    this.webSocketService.sendMessage(WebSocketMessageType.MaintenanceTaskCompleted, { action })
                )
            ),
        { dispatch: false }
    );
}
